import $ from 'jquery';
import 'matchHeight';

const matchHeights = ($target) => {

	var option = {
		byRow: true,
		property: 'min-height',
		target: null,
		remove: false
	};

	// c-products
	$target.find('.eq').matchHeight(option);

	// intro
	$target.find('.intro__content').matchHeight(option);

};

exports.init = matchHeights;



// WEBPACK FOOTER //
// ./src/js/components/matchHeights.js